import { WARNING_MINIMUM_DPI } from '@/domain/product/productDimensions';

// The canvas coordinate system is the print one: one unit is one pixel at `canvasDpi`. An
// image drawn at `scale` spreads its own pixels over `scale` times that surface, so its
// effective resolution is `canvasDpi / scale`. The source pixel count does not enter the
// comparison -- it cancels out, being what dictates the scale needed to cover a given area
// in the first place. Passing the threshold as the dividend is what reduced this whole
// function to `scale > 1`.
//
// A vector has no resolution to lose: it rasterises at the size it is drawn, however far it
// is enlarged, so warning on one is always a false positive.
function imageQualityChecker(params: { canvasDpi: number; isVector?: boolean; scaleX: number; scaleY: number }): boolean {
    const { canvasDpi, isVector = false, scaleX, scaleY } = params;
    if (isVector) {
        return false;
    }

    return canvasDpi / scaleX < WARNING_MINIMUM_DPI || canvasDpi / scaleY < WARNING_MINIMUM_DPI;
}

export { imageQualityChecker };
